export default __webpack_public_path__ + "static/1314-b505b0ce7ba242b445974767a4994e04.gif";